import {
  Box,
  FormControl,
  Typography,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import { tokens } from "../../theme";
import Header from "./Header";
import ApprovalDashboard from "./ApprovalDashboard/ProgressCircle";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AverageOrderValue from "./Sales Dashboard/AverageOrderValue";
import RegionWiseSD from "./Sales Dashboard/RegionWiseSales";
import CustomerTypeRatio from "./Sales Dashboard/NewVsRepeatCustmer";
import PurchasePriceVariance from "./Purchase Dashboard/PurchasePriceVariance";
import ReceivablesAgeingAnalysis from "./OutstandingDashboard/ReceivablesAgeingAnalysis";
import PayableAgeingAnalysis from "./CreditMgmtDashboard/PayableAgeingAnalysis";
import MonthlyPurchaseTrend from "./Purchase Dashboard/MonthlyPurchaseTrend";
import InvTurnoverRatio from "./Purchase Dashboard/InvTurnoverRatio";
import CollectionEfficiencyRatio from "./OutstandingDashboard/CollectionEfficiencyRatio";
import AverageCollectionPeriod from "./OutstandingDashboard/AverageCollectionPeriod";
import PaymentEfficiencyRatio from "./CreditMgmtDashboard/PaymentEfficiencyRatio";
import OverduePayableReport from "./CreditMgmtDashboard/OverduePayableReport";
import TopCustomersWithHighestDues from "./OutstandingDashboard/TopCustomerDues";
import TopSuppliersBySpend from "./Purchase Dashboard/TopSuppliersbySpend";

const Dashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const cmpname = localStorage.getItem("cmpname");
  const token = localStorage.getItem("token");
  const [open, setOpen] = useState(false);
  const [CmpNameList, setCmpNameList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(
    localStorage.getItem("cmpid")
  );
  const cmpid = localStorage.getItem("cmpid");
  const [selectedModule, setSelectedModule] = useState("approval");
  const role = localStorage.getItem("Role");
  const [isEmpty, setIsEmpty] = useState(false);
  const DefaultTab = localStorage.getItem("Selectedvalues");
  let defaultSelected;
  if (DefaultTab === "Module Dashboard") {
    defaultSelected = "approval";
  } else if (DefaultTab === "Sales Dashboard") {
    defaultSelected = "sales";
  } else if (DefaultTab === "Purchase Dashboard") {
    defaultSelected = "purchase";
  } else if (DefaultTab === "Outstanding Dashboard") {
    defaultSelected = "outstanding";
  } else {
    defaultSelected = "approval";
  }
  const [activeTab, setActiveTab] = useState(defaultSelected);
  const [ModuleDashBoard, setModuleDashBoard] = useState({
    isApproval: false,
    PayableAgeingReport: false,
    PaymentEfficiencyReport: false,
    // sales DashBoard var
    top10CustomersWithHighestDues: false,
    averageOrderValue: false,
    indianStatesSalesDistribution: false,
    newVsRepeatCustomers: false,
    //Purchase DashBoard var
    purchasePriceVariance: false,
    topSuppliersBySpend: false,
    //Outstading DashBoard var
    receivablesAgeingAnalysis: false,
    collectionEfficiencyRatio: false,
  });

  const [TabEnable, setTabEnable] = useState({
    ModuleTab: false,
    SaleDTab: false,
    PurchaseDTab: false,
    OutstandingDTab: false,
  });

  //=============================

  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  };

  const HandleRedirect = () => {
    navigate("/Member/ShraddhaEvents");
    window.location.reload();
  };

  const handleSelectChange = (event) => {
    const selectedId = event.target.value;
    const selectedCompany = CmpNameList.find(
      (cmp) => cmp.Cmp_Id === selectedId
    );
    localStorage.setItem("cmpid", selectedId);
    localStorage.setItem("cmpname", selectedCompany?.Cmp_Name);
    setSelectedCompanyId(selectedId);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleModuleChange = (event) => {
    setSelectedModule(event.target.value);
  };

  useEffect(() => {
    if (!cmpname) setOpen(true);
    fetchData();
    fetchDashList();
    FetchCategory();
  }, [cmpname]);

  // ==================================

  const fetchData = async () => {
    if (!token) {
      navigate("/Auth/");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/company/list",
        {},
        { headers: { Authorization: token } }
      );
      const UserListData = Object.values(response.data.companies);
      setCmpNameList(UserListData);
      setIsEmpty(UserListData.length === 0);
    } catch (error) {
      const UserListData = Object.values(error.response?.data?.companies || []);
      setCmpNameList(UserListData);
      setIsEmpty(UserListData.length === 0 || error.response?.status === 404);
      console.log("Error fetching data", error);
    }
  };

  const handleMdClose = () => setOpen(false);

  // =================================================

  const fetchDashList = async () => {
    try {
      const reponse = await axios.post(
        process.env.REACT_APP_API_URL + "/reports/config/list",
        { cmpid },
        { headers: { Authorization: token } }
      );

      const DashBoardEnable = Object.values(reponse.data);
      //  console.log(DashBoardEnable);

      DashBoardEnable.forEach((perm) => {
        if (perm.dashboard_name === "approvalModule") {
          ModuleDashBoard.isApproval = true;
        }

        if (perm.dashboard_name === "payableAgeingAnalysis") {
          ModuleDashBoard.PayableAgeingReport = true;
        }
        if (perm.dashboard_name === "paymentEfficiencyRatio") {
          ModuleDashBoard.PaymentEfficiencyReport = true;
        }
        // sales Dashbord visibility
        if (perm.dashboard_name === "top10CustomersWithHighestDues") {
          ModuleDashBoard.top10CustomersWithHighestDues = true;
        }
        if (perm.dashboard_name === "averageOrderValue") {
          ModuleDashBoard.averageOrderValue = true;
        }
        if (perm.dashboard_name === "indianStatesSalesDistribution") {
          ModuleDashBoard.indianStatesSalesDistribution = true;
        }

        if (perm.dashboard_name === "newVsRepeatCustomers") {
          ModuleDashBoard.newVsRepeatCustomers = true;
        }

        // Purchase Dashboard visibility

        if (perm.dashboard_name === "purchasePriceVariance") {
          ModuleDashBoard.purchasePriceVariance = true;
        }

        if (perm.dashboard_name === "topSuppliersBySpend") {
          ModuleDashBoard.topSuppliersBySpend = true;
        }

        // Outstading DashBoard visibility

        if (perm.dashboard_name === "receivablesAgeingAnalysis") {
          ModuleDashBoard.receivablesAgeingAnalysis = true;
        }

        if (perm.dashboard_name === "collectionEfficiencyRatio") {
          ModuleDashBoard.collectionEfficiencyRatio = true;
        }
      });

      setModuleDashBoard((prev) => ({ ...prev, ...ModuleDashBoard }));
      // console.log(ModuleDashBoard);
    } catch (error) {
      console.error("Error fetching Report  list:", error);
    }
  };

  //==========================================================

  const FetchCategory = async () => {
    try {
      const reponse = await axios.post(
        process.env.REACT_APP_API_URL + "/reports/config/category",
        { cmpid },
        { headers: { Authorization: token } }
      );

      const DashBoardTabEnable = Object.values(reponse.data);
      // console.log(DashBoardTabEnable);
      localStorage.setItem("Selectedvalues", DashBoardTabEnable[0]?.category);
      DashBoardTabEnable.forEach((perm) => {
        if (perm.category === "Module Dashboard") {
          TabEnable.ModuleTab = true;
        }
        if (perm.category === "Sales Dashboard") {
          TabEnable.SaleDTab = true;
        }
        if (perm.category === "Purchase Dashboard") {
          TabEnable.PurchaseDTab = true;
        }

        if (perm.category === "Outstanding Dashboard") {
          TabEnable.OutstandingDTab = true;
        }
      });

      setTabEnable((prev) => ({ ...prev, ...TabEnable }));
    } catch (error) {
      console.error("Error fetching Category list:", error);
    }
  };

  // ===============================

  return (
    <Box
      m="0px"
      sx={{
        width: "100%",
        maxWidth: "1600px",
        margin: "0 0",
        marginLeft: "0px", // Add this
        paddingLeft: "0px", // Add this
      }}
    >
      {/* Dialog: Company Selection */}
      <Dialog
        open={open}
        onClose={handleMdClose}
        PaperProps={{
          sx: {
            width: "500px",
            maxWidth: "90%",
            backgroundColor: colors.primary[400],
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: "15px",
            px: "16px",
            color: colors.primary[100],
          }}
        >
          Select Tally Company
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: 2,
            }}
          >
            {isEmpty ? (
              <Typography
                border={2}
                padding={1}
                borderRadius={1}
                sx={{
                  color: colors.redAccent[500],
                  borderColor: colors.redAccent[500],
                }}
              >
                Please add a company in Desktop Application
              </Typography>
            ) : (
              <FormControl fullWidth sx={{ minWidth: 200 }}>
                <InputLabel
                  id="Tally-Company-label"
                  sx={{ color: colors.primary[100] }}
                >
                  Select Tally Company
                </InputLabel>
                <Select
                  labelId="Tally-Company-label"
                  value={selectedCompanyId}
                  onChange={handleSelectChange}
                  fullWidth
                  variant="outlined"
                  label="Select Tally Company"
                  sx={{
                    color: colors.primary[100],
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: colors.blueAccent[300],
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: colors.blueAccent[500],
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: colors.blueAccent[700],
                    },
                  }}
                >
                  <MenuItem disabled value="">
                    <em style={{ color: colors.primary[100] }}>
                      Tally company list
                    </em>
                  </MenuItem>
                  {CmpNameList.map((cmpname) => (
                    <MenuItem
                      key={cmpname.Cmp_Id}
                      value={cmpname.Cmp_Id}
                      sx={{ color: colors.primary[100] }}
                    >
                      {cmpname.Cmp_Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={isEmpty ? HandleRedirect : handleClose}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: colors.primary[100],
              color: colors.primary[900],
              "&:hover": {
                backgroundColor: colors.blueAccent[700],
                color:colors.primary[100]
              },
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/* Main Dashboard Content */}
      <Box mt={9} mr={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header title="DASHBOARD" subtitle="Welcome to your Dashboard!" />
          {role === "admin" && (
            <Button
              variant="contained"
              size="small"
              sx={{
                height: "35px",
                minHeight: "35px",
                backgroundColor: colors.blueAccent[700],
                color: colors.primary[150],
                "&:hover": {
                  backgroundColor: colors.blueAccent[700],
                  color: colors.primary[150],
                },
              }}
              onClick={() => navigate("/Infinite/DashboardSettings")}
            >
              DashBoard Configuration
            </Button>
          )}
        </Box>

        {/* Tabs for different dashboards */}
        <Box
          sx={{
            mb: 2,
            "& .MuiTabs-indicator": {
              backgroundColor: colors.blueAccent[500],
            },
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            textColor="inherit"
            sx={{
              minHeight: 35,
              height: 35,
            }}
          >
            {(TabEnable?.ModuleTab || role === "admin") && (
              <Tab
                label="Modules Dashboard"
                value="approval"
                sx={{
                  minHeight: 35,
                  height: 35,
                  color:
                    activeTab === "approval"
                      ? colors.blueAccent[500]
                      : colors.grey[300],
                  "&.Mui-selected": {
                    color: colors.blueAccent[500],
                  },
                }}
              />
            )}
            {(TabEnable?.SaleDTab || role === "admin") && (
              <Tab
                label="Sales Dashboard"
                value="sales"
                sx={{
                  minHeight: 35,
                  height: 35,
                  color:
                    activeTab === "sales"
                      ? colors.blueAccent[500]
                      : colors.grey[300],
                  "&.Mui-selected": {
                    color: colors.blueAccent[500],
                  },
                }}
              />
            )}

            {(TabEnable?.PurchaseDTab || role === "admin") && (
              <Tab
                label="Purchase Dashboard"
                value="purchase"
                sx={{
                  minHeight: 35,
                  height: 35,
                  color:
                    activeTab === "purchase"
                      ? colors.blueAccent[500]
                      : colors.grey[300],
                  "&.Mui-selected": {
                    color: colors.blueAccent[500],
                  },
                }}
              />
            )}
            {(TabEnable?.OutstandingDTab || role === "admin") && (
              <Tab
                label="Outstanding Dashboard"
                value="outstanding"
                sx={{
                  minHeight: 35,
                  height: 35,
                  color:
                    activeTab === "outstanding"
                      ? colors.blueAccent[500]
                      : colors.grey[300],
                  "&.Mui-selected": {
                    color: colors.blueAccent[500],
                  },
                }}
              />
            )}
          </Tabs>
        </Box>

        {/* Dashboard Content */}

        {activeTab === "approval" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap="10px">
            {(TabEnable?.ModuleTab || role === "admin") && (
              <Box gridColumn="span 12" sx={{ mb: 1 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="module-select-label"
                    sx={{ color: colors.primary[100] }}
                  >
                    Select Module
                  </InputLabel>
                  <Select
                    labelId="module-select-label"
                    id="module-select"
                    value={selectedModule}
                    label="Select Module"
                    onChange={handleModuleChange}
                    sx={{
                      minHeight: 35,
                      height: 35,
                      color: colors.primary[100],
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#000000",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#000000",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#000000",
                      },
                    }}
                  >
                    {(ModuleDashBoard?.isApproval === true ||
                      role === "admin") && (
                      <MenuItem value="approval">Approval Module</MenuItem>
                    )}
                    {(ModuleDashBoard?.PayableAgeingReport ||
                      ModuleDashBoard?.PaymentEfficiencyReport ||
                      role === "admin") && (
                      <MenuItem value="credit">
                        Credit Management Module
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>
            )}
            {((selectedModule === "approval" && ModuleDashBoard?.isApproval) ||
              (selectedModule === "approval" && role === "admin")) && (
              <Box gridColumn="span 12">
                <ApprovalDashboard />
              </Box>
            )}
            {selectedModule === "credit" && (
              <>
                {(ModuleDashBoard?.PayableAgeingReport === true ||
                  role === "admin") && (
                  <Box gridColumn="span 12">
                    <PayableAgeingAnalysis />
                  </Box>
                )}
                {(ModuleDashBoard?.PaymentEfficiencyReport === true ||
                  role === "admin") && (
                  <Box gridColumn="span 12">
                    <PaymentEfficiencyRatio />
                  </Box>
                )}

                {/* <Box gridColumn="span 12">
                  <OverduePayableReport />
                </Box> */}
              </>
            )}
          </Box>
        )}

        {/* ============================== */}

        {activeTab === "sales" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap="20px">
            {(ModuleDashBoard?.averageOrderValue === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <AverageOrderValue />
              </Box>
            )}

            {(ModuleDashBoard?.indianStatesSalesDistribution === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <RegionWiseSD />
              </Box>
            )}

            {(ModuleDashBoard?.newVsRepeatCustomers === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <CustomerTypeRatio />
              </Box>
            )}
            {(ModuleDashBoard?.indianStatesSalesDistribution === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <TopCustomersWithHighestDues />
              </Box>
            )}
          </Box>
        )}

        {activeTab === "purchase" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap="20px">
            {(ModuleDashBoard?.purchasePriceVariance === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <PurchasePriceVariance />
              </Box>
            )}
            {/* <Box gridColumn="span 12">
              <MonthlyPurchaseTrend />
            </Box> */}
            {/* <Box gridColumn="span 12">
              <InvTurnoverRatio />
            </Box> */}
            {(ModuleDashBoard?.topSuppliersBySpend === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <TopSuppliersBySpend />
              </Box>
            )}
          </Box>
        )}

        {activeTab === "outstanding" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap="20px">
            {(ModuleDashBoard?.receivablesAgeingAnalysis === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <ReceivablesAgeingAnalysis />
              </Box>
            )}
            {(ModuleDashBoard?.collectionEfficiencyRatio === true ||
              role === "admin") && (
              <Box gridColumn="span 12">
                <CollectionEfficiencyRatio />
              </Box>
            )}
            {/* <Box gridColumn="span 12">
              <AverageCollectionPeriod />
            </Box> */}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;
